import { Link, useLocation, useParams } from 'react-router-dom';

export const UserMenu = () => {
  const { identifier } = useParams();

  return (
    <li className="nav-item dropdown d-flex align-items-center">
      <Link to="" className="nav-link text-body p-0" data-bs-toggle="dropdown" aria-expanded="false">
        <i className="fa fa-user cursor-pointer"></i>
      </Link>
      <ul className={`dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4`} data-bs-popper="static">
        <li className="mb-2">
          <Link className="dropdown-item border-radius-md py-1" to="/workspaces">
            <div className="d-flex align-items-center text-sm">
              <i className="fas fa-user"></i>
              <span className="px-1">スペースの切り替え</span>
            </div>
          </Link>
        </li>
        <li className="mb-2">
          <Link className="dropdown-item border-radius-md py-1" to={`/my_profile`}>
            <div className="d-flex align-items-center">
              <i className="fas fa-cog"></i>
              <span className="px-1">アカウント設定</span>
            </div>
          </Link>
        </li>
        {identifier && (
          <li className="mb-2">
            <Link className="dropdown-item border-radius-md py-1" to={`/w/${identifier}/user_setting/notification`}>
              <div className="d-flex align-items-center">
                <i className="fas fa-bell"></i>
                <span className="px-1">通知設定</span>
              </div>
            </Link>
          </li>
        )}
      </ul>
    </li>
  );
};
